import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssistantPage from './AssistantPage';

/** Pages under /casa/dizer. */
const AssistantRoutes: React.FC = () => (
  <Routes>
    <Route index element={<AssistantPage />} />
  </Routes>
);

export default AssistantRoutes;
